import environment from '../environment/index.js';
var ACCESSTOKEN = 'accessToken';
var REFESHTOKEN = 'refeshToken';
var USERINFO = 'userInfo';
var storage = {
  get: function (key) {
    return localStorage.getItem(key);
  },
  set: function (key, value) {
    localStorage.setItem(key, value);
  },
  "delete": function (key) {
    localStorage.removeItem(key);
  },
  clear: function () {
    localStorage.clear();
  },
  getAccessToken: function () {
    var token = this.get("" + environment.getApiEnv() + ACCESSTOKEN) || '';
    return token;
  },
  setAccessToken: function (token) {
    this.set("" + environment.getApiEnv() + ACCESSTOKEN, token);
  },
  getRefreshToken: function () {
    var token = this.get("" + environment.getApiEnv() + REFESHTOKEN) || '';
    return token;
  },
  getUserInfo: function () {
    var userInfo = this.get("" + environment.getApiEnv() + USERINFO) || '';
    if (userInfo) {
      var userInfoObject = JSON.parse(userInfo);
      return userInfoObject;
    }
    return null;
  }
};
export default storage;